import request from '@/router/axios';
export function getListpage(obj) {
  return request({
    url: '/emp/page',
    method: 'POST',
    data: obj,
  });
}
/**
 *  获取动态表单回显值
 */
export function getDynamicFormValue(cusId) {
  return request({
    url: '/emp/getEmpInfo/'+cusId,
    method: 'GET',
  });
}
/**
 *  根据id修改数据
 * @param obj
 */
export function updateListpage(obj) {
  return request({
    url: '/emp/update',
    method: 'put',
    data: obj,
  });
}

export function addListpage(obj) {
  return request({
    url: '/emp/add',
    method: 'post',
    data: obj,
  });
}
export function batchUpdateStatus(obj) {
  return request({
    url: '/emp/batchUpdate',
    method: 'post',
    data: obj,
  });
}
//导出员工
export function exportEmp(obj) {
  return request({
    url: '/emp/exportEmp',
    responseType: 'blob', // 代表内存之中的一段二进制数据 必须加
    method: 'get',
    params: obj
  })
}
//导出模板
export function exportNullExcel() {
  return request({
    url: '/emp/exportNullExcel',
    responseType: 'blob', // 代表内存之中的一段二进制数据 必须加
    method: 'get'
  })
}
//删除员工
export function delEmpInfoById() {
  return request({
    url: '/emp/deleteApprInfoById',
    method: 'post',
  })
}
